module.exports = __webpack_public_path__ + "img/banner.afc2598e.png";